import React, { useEffect, useMemo, useState } from "react";
import LazyImage from "../work/travelPageTemplate/LazyLoadImages";

function useColumnCount() {
  const get = () => {
    if (typeof window === "undefined") return 3;
    if (window.innerWidth >= 1200) return 3;
    if (window.innerWidth >= 720) return 2;
    return 1;
  };
  const [cols, setCols] = useState(get);
  useEffect(() => {
    const onResize = () => setCols(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return cols;
}

/**
 * Masonry that PRESERVES sequence (round-robin distribution, not CSS
 * `columns`, which reorders column-major and destroys a curated edit).
 *
 * Each item carries a reveal delay of column-index * 80ms, so when a row
 * scrolls into view it cascades left-to-right -- the "populating" feel.
 *
 * NOTE on image protection: onContextMenu/draggable are friction only —
 * see Lightbox.jsx for the same caveat. Not a security control.
 */
export default function MasonryGrid({ items, onSelect }) {
  const cols = useColumnCount();

  const columns = useMemo(() => {
    const out = Array.from({ length: cols }, () => []);
    items.forEach((item, i) => out[i % cols].push({ item, i }));
    return out;
  }, [items, cols]);

  return (
    <div className="masonry">
      {columns.map((col, c) => (
        <div className="masonry-col" key={c}>
          {col.map(({ item, i }) => (
            <button
              key={item.name || i}
              onClick={() => onSelect && onSelect(i)}
              onContextMenu={(e) => e.preventDefault()}
              aria-label={`View ${item.caption || "photograph"}`}
            >
              <LazyImage
                src={item.url}
                alt={item.caption || ""}
                revealDelay={c * 80}
                draggable={false}
              />
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}